import React from 'react'
import './DeleteRecurringDialog.css'

/**
 * Modal dialog for deleting recurring availability
 * Offers choice between deleting single instance or all instances
 */
function DeleteRecurringDialog({ onDeleteThis, onDeleteAll, onCancel }) {
  return (
    <div className="delete-recurring-overlay" onClick={onCancel}>
      <div
        className="delete-recurring-dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="delete-recurring-header">
          <h3>Delete Recurring Availability</h3>
        </div>

        <div className="delete-recurring-body">
          <p>
            This is a recurring availability. What would you like to delete?
          </p>
        </div>

        <div className="delete-recurring-actions">
          <button
            className="btn btn-secondary"
            onClick={onCancel}
            type="button"
          >
            Cancel
          </button>
          <button
            className="btn btn-warning"
            onClick={onDeleteThis}
            type="button"
          >
            This Instance Only
          </button>
          <button
            className="btn btn-danger"
            onClick={onDeleteAll}
            type="button"
          >
            All Instances
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeleteRecurringDialog
